import React, { Fragment, useContext } from 'react'
import AppContext from '../context'
import { graphql } from "gatsby"
import SEO from "../components/SEO"
import Header from "../components/header"
import Main from "../components/main"
import Footer from "../components/footer"
import Nav from "../components/nav"
import AgeHeader from '../components/age-header'
import AgeTitle from '../components/age-title'
import AgeStats from '../components/age-stats'
import BookList from '../components/book-list'
import getBooksCompleted from '../helpers/getBooksCompleted'
import TweetButton from '../components/tweet-button'

function generateTweetText(numCompleted, age, isComplete) {
  if (isComplete) {
    return `I've read all the books from the ${age} category as part of @inputsenpai's picture book challenge! やった！`
  }
  
  const book = numCompleted === 0 || numCompleted > 1 ? 'books' : 'book'
  return `I've read ${numCompleted} ${book} from the ${age} category as part of @inputsenpai's picture book challenge! やった！`
}

function AgePage(props) {
  const { completedBooks, toggleBookComplete } = useContext(AppContext)
  const completedByAge = getBooksCompleted(completedBooks, props.pageContext.age)
  const books = props.data.postgres.ageById.booksByAge.nodes
  const site = props.data.site.siteMetadata
  const pageUrl = `${site.url}/${props.pageContext.slug}`
  const isComplete = books.length === completedByAge.length
  const tweetText = generateTweetText(completedByAge.length, props.pageContext.age, isComplete)

  return (
    <Fragment>
      <SEO
        title={`${props.pageContext.age} | ${site.title}`}
        description={`Take the ${props.pageContext.age} challenge by reading mountains of Japanese children's books. Learn Japanese along the way.`}
        url={pageUrl}
        imgUrl={`${site.url}/${props.pageContext.slug}_banner_02.png`}
      />
      <Nav />
      <Header siteTitle={site.title} />
      <Main>
        <AgeHeader>
          <AgeTitle text={props.pageContext.age} />
          <AgeStats read={completedByAge.length} unread={books.length - completedByAge.length} />
          <TweetButton
            url={pageUrl}
            text={tweetText}
            hashtags='えほんのチャレンジ'
          />
        </AgeHeader>
        {books && books.length > 0 && (
          <BookList
            age={props.pageContext.age}
            books={books}
            completedBooks={completedByAge}
            toggleBookComplete={toggleBookComplete}
          />
        )}
      </Main>
      <Footer />
    </Fragment>
  )
}

export const query = graphql`
  query AgePageQuery($ageId: String!) {
    site {
      siteMetadata {
        title
        description
        url
      }
    }
    postgres {
      ageById(id: $ageId) {
        booksByAge {
          nodes {
            title
            url
            readAloudUrl
          }
        }
      }
    }
  }
`

export default AgePage
